import React from "react";
import * as Cesium from 'cesium';
import AnnotationName from "../AnnotationName";
import ProjectDescription from "../ProjectDescription";
import ColorPicker from "components/common/ColorPicker";
import { generateNodeImage } from "../../../../MapView/MapUtils"
import useProjectStore from "../../../../../store-zustand/project"

const NonMarkerSettings = ({ annotation }) => {
  const { setcurrentAnnotationColor, setcurrentAnnotationAlpha, setcurrentAnnotationWidth } = useProjectStore();

  const handlePickedColor = (csscolor) => {
    setcurrentAnnotationColor(csscolor);
    if (window.activeShape) {
      window.activeShape.FillColor = Cesium.Color.fromCssColorString(csscolor);
      window.activeShape.Polygonoutlinecolor = Cesium.Color.fromCssColorString(csscolor);
      window.activeShape.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
        color: Cesium.Color.fromCssColorString(csscolor),
        outlineColor: Cesium.Color.fromCssColorString(csscolor)
      });

      window.lineNodes.map((entity, index) => {
        let circleImage = generateNodeImage(csscolor, true);
        entity.billboard.image = circleImage;
      });

      if (window.floatingPoint) {
        let circleImage = generateNodeImage(csscolor, true);
        window.floatingPoint.billboard.image = circleImage;
      }
    } else if (window.annotationObj[`${window.actualAnnotationId}`]) {
      window.annotationObj[`${window.actualAnnotationId}`].FillColor = Cesium.Color.fromCssColorString(csscolor);
      window.annotationObj[`${window.actualAnnotationId}`].Polygonoutlinecolor = Cesium.Color.fromCssColorString(csscolor);
    }
  }

  const getAnnotationEntity = (id) => {
    if (window.GlobalAnnotationEntities && window.GlobalAnnotationEntities.entities) {
      const entities = window.GlobalAnnotationEntities.entities.values;
      return entities.find(entity => entity._id === id);
    }

    return undefined;
  }

  const changeEntityLineWidth = (annotation_index, width) => {
    const annotation_id = window.annotationObj[annotation_index]['Idannotation']
    const entity = getAnnotationEntity(annotation_id);
    if (entity) {
      if (entity.name == 'Polygon') {
        const outline_entity = getAnnotationEntity(`${annotation_id}PolygonOutline`);
        outline_entity.polyline.width = width;
      } else {
        entity.polyline.width = width;
      }
    }
  }

  const changePolygonEntityOpacity = (annotation_index, alpha) => {
    const annotation_id = window.annotationObj[annotation_index]['Idannotation']
    const entity = getAnnotationEntity(annotation_id);
    if (entity) {
      entity.polygon.material = Cesium.Color.fromCssColorString('#FFFFFF').withAlpha(alpha);
    }
  }

  const handleFeatureWidth = (width) => {
    setcurrentAnnotationWidth(width);
    if (window.activeShape) {
      window.activeShape.LineWidth = width;
      window.activeShape.polyline.width = width;
    } else if (window.annotationObj[`${window.actualAnnotationId}`]) {
      window.annotationObj[`${window.actualAnnotationId}`].LineWidth = width;
      changeEntityLineWidth(`${window.actualAnnotationId}`, width);
    }
  }

  const changePolylineOpacity = (alpha) => {
    if (window.activeShape) {
      window.activeShape.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
        color: window.activeShape.polyline.material.color._value.withAlpha(alpha),
        outlineColor: window.activeShape.polyline.material.color._value.withAlpha(alpha)
      });
      window.activeShape.LineFillTransparency = alpha;
    } else if (window.annotationObj[`${window.actualAnnotationId}`]) {
      window.annotationObj[`${window.actualAnnotationId}`].LineFillTransparency = alpha;
    }
  }
  
  const changePolygonOpacity = (alpha) => {
    if (window.activeShape) {
      window.activeShape.PolygonFillTransparency = alpha;
      window.activeShape.polygon.material = Cesium.Color.fromCssColorString('#FFFFFF').withAlpha(alpha);
    } else if (window.annotationObj[`${window.actualAnnotationId}`]) {
      window.annotationObj[`${window.actualAnnotationId}`].PolygonFillTransparency = alpha;
      changePolygonEntityOpacity(`${window.actualAnnotationId}`, alpha);
    }
  }

  const handlePickedOpacity = (opacity, type) => {
    let alpha = opacity * 0.01;
    setcurrentAnnotationAlpha(alpha);
    if (type === 'Line') {
      changePolylineOpacity(alpha);
    } else {
      changePolygonOpacity(alpha);
    }
  }

  const LabelColorvalue = (color) => {
    window.annotationObj[`${window.actualAnnotationId}`].LabelfillColor = Cesium.Color.fromCssColorString(color);
  }

  const Labelsizevalue = (size) => {
    if (size === 1) {
      window.annotationObj[`${window.actualAnnotationId}`].Labelfontsize = '11px';
    } else if (size === 2) {
      window.annotationObj[`${window.actualAnnotationId}`].Labelfontsize = '14px';
    } else {
      window.annotationObj[`${window.actualAnnotationId}`].Labelfontsize = '8px';
    }
  }

  const handleLabelVisibility = (visibility) => {
    if (visibility === 1) {
      window.annotationObj[`${window.actualAnnotationId}`].LabelVisibility = true;
    } else {
      window.annotationObj[`${window.actualAnnotationId}`].LabelVisibility = false;
    }
  }

  return (
    <div>
      <AnnotationName name={annotation.name} type={annotation.type} />
      <ProjectDescription description={annotation.description} />
      <ColorPicker label="Styling" handlePickedColor={handlePickedColor} handleFeatureWidth={handleFeatureWidth} handlePickedOpacity={handlePickedOpacity} Labelsizevalue={Labelsizevalue} LabelColorvalue={LabelColorvalue} handleLabelVisibility={handleLabelVisibility} type={annotation.type} />
    </div>
  );
};

export default NonMarkerSettings;